import $ from 'jquery'

export function smartalbumsTrialDownloadSignupFollow() {
  var redirectUrl = $('.signup-follow-download-url').attr('href');
  $('#download_iframe').attr('src', redirectUrl);
}
